// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"141":"component---src-components-post-tsx","246":"component---src-pages-tsx"}[chunkId] || chunkId) + "-" + {"141":"828104cadc72de88a742","246":"795220a9cb4ed85db760","452":"0b8ded9dabcb64f6f053","896":"49c70586a874b203dc36"}[chunkId] + ".js";
};